export const formatText = (text) => String(text ?? '')
  .replace(/~([^~\n]*[^~\s])~/g, '<s>$1</s>')
  .replace(/(?<!\b(?:https:\/\/|http:\/\/|www\.\w+\.\w+)\/[^\s]*|\/[^\s]*)_(.*?)_(?![^\s]*\.\w{2,}(?:\/[^\s]*)?(?:\?[_\w]+)?)/g, '<i>$1</i>')
  .replace(/\*([^*\n]*[^*\s])\*/g, '<b>$1</b>')
  .replace(/`{3}([^`\n]*[^`\s])`{3}/g, '<pre class="d-inline-block pre-message">$1</pre>');

export const formatTextToSend = (text) => String(text ?? '')
  .replace(/<br>/g, "\n")
  .replace(/\&amp;/g, '&');

export const splitFullName = (fullname) => {
  const names = fullname.split(' ');
  const size = names.length;

  if (size % 2 !== 0) {
    names.unshift('');
  }

  const firstName = names.slice(0, size / 2).join(' ');
  const lastName = names.slice(size / 2).join(' ');

  return { firstName, lastName };
};
